import qs from 'qs';
import axios from 'axios'
import store from '../vuex/store';
import {
  Message,
  MessageBox
} from 'element-ui';
import router from '../../src/router/index.js'

axios.defaults.timeout = 60000; // 请求超时
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
axios.defaults.withCredentials = true; // 允许跨域携带cookie



// 添加请求拦截器
axios.interceptors.request.use(function(config) {
  config.headers['Accept'] = "*/*"
  if (localStorage.getItem('logintoken_shop')) {
    config.headers['Authori-zation'] = 'Bearer ' + localStorage.getItem('logintoken_shop')
  } else {
    config.headers['Authori-zation'] = 'Bearer '
  }
  config.headers['shop-id'] = localStorage.getItem('c_shopId')
  config.headers['platform'] = 'pc'
  return config;
}, function(error) {
  // 对请求错误做些什么
  return Promise.reject(error);
});


// 添加响应拦截器
axios.interceptors.response.use(function(res) {
  if (res.status != 200) {
      Message.error("请求异常,错误信息：" + res.statusText + "！");
    }
    if(!(res.data instanceof Blob)){
      if (res.data.status != 200 && res.data.status != 1001 && res.data.status != 1000 && res.data.status != 1002) {
        if (res.data.msg) {
          Message.error(res.data.msg);
        } else if (res.data.message) {
          Message.error(res.data.message);
        }
      }
    }
    // 未登录 登录失效
    if (res.data.status == 1000) {
      localStorage.setItem('logintoken_shop', '')
      localStorage.setItem('userdata_shop', '')
      localStorage.setItem('ishavaStore', '')
      setTimeout(function() {
        router.push('/login');
      }, 500)
    }
    // 店铺冻结
    if (res.data.status == 1002) {
      if(window.location.hash.indexOf('/login')==-1){
        setTimeout(function(){
          router.push('/login');
        },1000)
      }else{
        Message.error(res.data.msg);
      }
    }

    // 刷新了token 则重新存放
    if (!isEmpty(res.headers.authorization)) {
      var token = res.headers.authorization.split(" ")[1];
      localStorage.setItem('token', token);
    }

    return res;
  }, function(err) {
    // eslint-disable-next-line no-console
    // console.log(err);

    // 如果地址无法请求
    if (isEmpty(err.response)) {
      Message.error("网络异常，请检查！");
    }

    // 存在状态码
    if (err.response.status) {
      switch (err.response.status) {
        case 404:
          Message.error('error_code:404');
          break;
        case 500:
          Message.error('error_code:500');
          break;
        default:
          // Message.error(err.response.statusText+",error_code："+err.response.status);
          Message.error("error_code：" + err.response.data.msg);
          break;
      }

    } else {
      Message.error("未知错误,错误信息：" + err.response.statusText + "！");
    }

    // 对响应错误做点什么
    return Promise.reject(err);
});


/*对象转json*/
export function toJson(data) {
  var json = qs.stringify(data);
  return json;
}

/*判断是否为空*/
export function isEmpty(str) {
  if (str === '' || str === null || str === undefined) {
    return true;
  }
  return false;
}


/**
 * get方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function get(url, params) {
  return new Promise((resolve, reject) => {
    axios.get(url, {
        params: params
      })
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(err.data)
      })
  });
}

export function put(url, params) {
  return new Promise((resolve, reject) => {
    axios.put(url, {
        params: params
      })
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(err.data)
      })
  });
}

export function deletes(url, params) {
  return new Promise((resolve, reject) => {
    axios.delete(url, {
        data: params
      })
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(err.data)
      })
  });
}


export function patch(url, params) {
  return new Promise((resolve, reject) => {
    axios.patch(url, params)
      .then(response => {
        resolve(response.data);
      }, err => {
        reject(err)
      })
  })
}
/**
 * post方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
// export function post(url, params) {
//   return new Promise((resolve, reject) => {
//     axios.post(url, qs.stringify(params))
//       .then(res => {
//         resolve(res.data);
//       })
//       .catch(err => {
//         reject(err.data)
//       })
//   });
// }
export function post(url, params, config = {}) {
  if(url.indexOf("release_part")>-1){   
     return new Promise((resolve, reject) => {
    axios.post(url, params, {
      ...config, // 合并自定义配置
      headers: {
        'Content-Type': 'application/json;charset=UTF-8'

      }
    })
    .then(res => {
      resolve(res.data);
    })
    .catch(err => {
      reject(err && err.response ? err.response.data : err);
    });
  });
  }else{
  return new Promise((resolve, reject) => {
    axios.post(url, qs.stringify(params), {
      ...config, // 合并自定义配置
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
      }
    })
    .then(res => {
      resolve(res.data);
    })
    .catch(err => {
      reject(err && err.response ? err.response.data : err);
    });
  });
  }

}

export function uploadImg(url, data) {
  return new Promise((resolve, reject) => {
    axios.post(url, data, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(err.data)
      })
  });
}
//Vue.use(axios)



// WEBPACK FOOTER //
// ./src/utils/http.js